import { message, notification } from 'antd';
import axios from 'axios';
import { config } from '../config/_const';
import i18n from '../config/i18n';

//var axios = require('axios');

message.config({
  duration: 5
});

notification.config({
  placement: 'topLeft',
  duration: 10
});

class BaseRequest {
  constructor() {
    this.successCallback = null;
    this.errorCallback = null;
    this.progressCallback = null;
    this.withFile = false;
    this.cancelToken = undefined;
    this.params = {};
    this.data = {};
    this.file = null;
    this.instance = null;
    this.mantainNotification = false;
    this.block_notification = false;
  }

  /**
   * Crea richiesta http
   *
   * @param  {Object} cancelToken      parametro per annullare la chiamata
   * @param  {Object} params           Parametri per query string
   * @param  {Object} data             Parametri POST e PUT
   * @param  {Object} file             File da inserire come formData
   * @param  {String} method           GET|POST|PUT|DELETE
   * @param  {String} url              Url
   * @param  {Function} successCallback  Callback ok
   * @param  {Function} errorCallback    Callback error
   * @param  {Function} progressCallback Callback progress tracking
   * @return {void}
   *
   * @method
   * @public
   */
  async makeRequest(
    params = {},
    data = {},
    file = null,
    method = 'get',
    url = '/',
    successCallback = null,
    errorCallback = null,
    progressCallback = null,
    mantainNotification = false,
    block_notification = false,
    base,
    cancelToken = null
  ) {
    if (params.withFile) {
      this.withFile = true;
    }

    this.successCallback = successCallback;
    this.errorCallback = errorCallback;
    this.progressCallback = progressCallback;

    this.params = params;
    this.data = data;
    this.file = file;
    this.mantainNotification = mantainNotification;
    this.block_notification = block_notification;
    this.cancelToken = cancelToken;

    this.instance = axios.create({
      baseURL:
        config.url[`API_URL_${base}`] +
        (config.url.API_PORT ? ':' + config.url.API_PORT : '') +
        url,
      timeout: '30s',
      headers: {
        ...axios.defaults.headers
      }
    });

    return this.doCall(url, method);
  }

  /**
   * Effettua la richiesta e richiama la callback in base al responso
   *
   * @param  {String} url    Url
   * @param  {String} method Metodo
   * @return {void}
   *
   * @method
   * @public
   */
  async doCall(url, method) {
    const axios_config = {
      method: method === 'get_file' ? 'post' : method === 'post_file' ? 'post' : method,
      headers: {
        ...axios.defaults.headers,
        'content-type': 'application/json',
        language: i18n.language,
        Authorization: localStorage.getItem('agi-token')
          ? 'Bearer ' + localStorage.getItem('agi-token')
          : null
      },
      cancelToken: this.cancelToken,
      params: this.params,
      data: this.data,
      responseType: method === 'get_file' || method === 'post_file' ? 'blob' : 'json',
      onUploadProgress: function () {
        if (this.progressCallback) {
          this.progressCallback();
        }
      },
      maxRedirects: 0
    };

    if (this.file) {
      const formData = new FormData();

      if (Array.isArray(this.file)) {
        this.file.forEach((f, n) => formData.append(f.chiave + '[' + n + ']', f.file));
      } else {
        formData.append(this.file.chiave, this.file.file);
      }

      const data_array_keys = Object.keys(this.data);
      if (data_array_keys.length > 0) {
        if (data_array_keys.length > 0) {
          data_array_keys.forEach((key) => {
            if (typeof this.data[key] === 'string' || typeof this.data[key] === 'number') {
              if (this.data[key] !== null) {
                formData.append(key, this.data[key]);
              }
            } else {
              if (this.data[key] !== null) {
                formData.append(key, JSON.stringify(this.data[key]));
              }
            }
          });
        }
      }

      axios_config.headers = {
        //...axios.defaults.headers,
        ...axios_config.headers,
        'content-type': 'multipart/form-data'
      };
      axios_config.data = formData;
    }

    return this.instance
      .request(axios_config)
      .then((response) => {
        if (this.successCallback) {
          this.successCallback(response);
        }
        return response;
      })
      .catch(async (e) => {
        console.error(e);

        if (axios.isCancel(e)) {
          return;
        }

        if (this.block_notification) {
          return;
        }

        if (e.response && e.response.status && e.response.status === 419) {
          notification.warning({
            message: i18n.t('notifications.warnings.title'),
            description: i18n.t('notifications.warnings.lockMessage')
          });
          if (this.errorCallback) {
            this.errorCallback(e);
          }
          return Promise.reject(e);
        }

        //MIO TEST
        if (e.response && e.response.status && e.response.status === 422) {
          notification.warning({
            message: 'Operazione non consentita',
            description: 'Rilevata relazione ricorsiva'
          });
          if (this.errorCallback) {
            this.errorCallback(e);
          }
          return Promise.reject(e);
        }

        if (e.response && e.response.status && e.response.status === 400) {
          notification.error({
            message: 'Errore di sistema',
            description:
              e.response.data?.exeption || e.response.data?.title || e.response.data || ''
          });
          if (this.errorCallback) {
            this.errorCallback(e);
          }
          return Promise.reject(e);
        }

        const showed_error = false;

        /**
         * Non ho potuto fare il parse della response
         */
        if (!showed_error) {
          //message.error('Errore non definito');

          notification.error({
            message: 'Errore non definito',
            description: "Contatta l'amministrazione per maggiori dettagli"
          });
        }
        if (this.errorCallback) {
          this.errorCallback(e);
        }
        return Promise.reject(e);
      });
  }

  async parseBlob(blob) {
    try {
      const blobbed_error = await this.readFile(blob);
      return JSON.parse(blobbed_error).data;
    } catch (e) {
      return '';
    }
  }

  async readFile(content) {
    const fileReader = new FileReader();
    return new Promise((resolve, reject) => {
      fileReader.onerror = () => {
        fileReader.abort();
        reject(new Error('Problem parsing file'));
      };

      fileReader.onload = () => {
        resolve(fileReader.result);
      };

      fileReader.readAsText(content);
    });
  }
}

/**
 * @component
 */
export default BaseRequest;
